import API_BASE from "./apiClient";

// Cross-origin calls to the API are rewritten into "simple" CORS requests (no custom headers,
// text/plain bodies, GET/POST only, cookies included). Host bot protection answers CORS preflights
// without CORS headers, so any request that needs a preflight fails with "Failed to fetch".
const nativeFetch = window.fetch.bind(window);

let apiUrl = null;
try { apiUrl = new URL(API_BASE, window.location.origin); } catch { /* relative or invalid base */ }
const crossOrigin = apiUrl && apiUrl.origin !== window.location.origin;

let priming = null;
function primeApiHost() {
  if (priming) return priming;
  priming = new Promise(resolve => {
    const frame = document.createElement("iframe");
    frame.style.display = "none";
    frame.src = `${apiUrl.origin}/api/health`;
    let loads = 0;
    const finish = () => { frame.remove(); resolve(); };
    frame.onload = () => { loads += 1; if (loads >= 2) finish(); };
    document.body.appendChild(frame);
    window.setTimeout(finish, 12000);
  }).finally(() => { window.setTimeout(() => { priming = null; }, 30000); });
  return priming;
}

function rewrite(url, init) {
  const target = new URL(url);
  const headers = new Headers(init.headers || {});
  const auth = headers.get("Authorization");
  if (auth) target.searchParams.set("access_token", auth.replace(/^Bearer\s+/i, ""));
  let method = String(init.method || "GET").toUpperCase();
  if (["PUT", "PATCH", "DELETE"].includes(method)) {
    target.searchParams.set("_method", method);
    method = "POST";
  }
  const next = { method, credentials: "include", body: init.body, signal: init.signal };
  if (typeof init.body === "string") next.headers = { "Content-Type": "text/plain;charset=UTF-8" };
  return [target.toString(), next];
}

if (crossOrigin) {
  window.fetch = async (input, init = {}) => {
    const url = typeof input === "string" ? input : input instanceof URL ? input.href : null;
    if (!url || !url.startsWith(apiUrl.origin + "/")) return nativeFetch(input, init);
    const [target, options] = rewrite(url, init);
    try {
      return await nativeFetch(target, options);
    } catch (error) {
      if (!(error instanceof TypeError)) throw error;
      await primeApiHost();
      return nativeFetch(target, options);
    }
  };
}
